export default {
  filters: {
    contraction: (value, maxLength = 20) => {
      const half = maxLength / 2;

      if (value.length > maxLength) {
        return value.slice(0, half).trim() + "..." + value.slice(-half).trim();
      }

      return value;
    }
  },
  install(Vue) {
    const filters = Object.keys(this.filters);

    filters.forEach(k => Vue.filter(k, this.filters[k]));
  }
};



// WEBPACK FOOTER //
// ./src/common/filters.js